import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=841acd28"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports